import { SuperInput } from "@components:SuperInput/SuperInput";
import { Toggle } from "@components:Toggle";
import { useDebounce } from "@hooks:useDebounce";
import { Box, InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import { Header } from "@pages:settings/Header";
import { OrganizationModal } from "@pages:settings/Tenent/Organizations/OrganizationModal";
import { OrganizationsTable } from "@pages:settings/Tenent/Organizations/OrganizationsTable";
import {
  useOrganizationsActions,
  useOrganizationsData,
} from "@stores:settings/organizations";
import { useEffect, useState } from "react";
import { IoMdSearch } from "react-icons/io";
import { MdClear, MdDomainAdd } from "react-icons/md";

const states = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];

export const Organizations = () => {
  const { searchKeyword, state } = useOrganizationsData();
  const { setSearchKeyword, setState, unMount } = useOrganizationsActions();
  const [isOpenModalToCreate, setIsOpenModalToCreate] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  useEffect(() => {
    return () => {
      unMount();
    };
  }, [unMount]);

  const onChange = () => {
    setSearchKeyword(searchKey);
  };

  const debouncedOnChange = useDebounce(onChange, 0);

  return (
    <Box
      className="Settings__Organizations"
      sx={{
        width: "100%",
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        leftSide={
          <Toggle state={state} allState={states} setState={setState} />
        }
        rightSide={
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<MdDomainAdd />}
              onClick={() => {
                setIsOpenModalToCreate(true);
              }}
            >
              Add Organization
            </Button>
            <SuperInput.TextField
              autoHeight={false}
              placeholder="Search by name"
              value={searchKey}
              onChange={(e) => {
                debouncedOnChange();
                setSearchKey(e.target.value);
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        backgroundColor: "transparent",
                      }}
                    >
                      <IoMdSearch size={20} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        cursor: "pointer",
                        visibility: searchKeyword ? "visible" : "hidden",
                      }}
                      onClick={() => {
                        debouncedOnChange();
                        setSearchKey("");
                      }}
                    >
                      <MdClear size={20} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>
        }
      />
      <Box
        sx={{
          flex: 1,
          minHeight: "0",
          pt: "2.5rem",
          px: "2.5rem",
        }}
      >
        <OrganizationsTable />
      </Box>
      {isOpenModalToCreate && (
        <OrganizationModal
          isOpen={isOpenModalToCreate}
          onClose={() => setIsOpenModalToCreate(false)}
        />
      )}
    </Box>
  );
};
